import React, { Component } from 'react';
import { Button } from 'reactstrap';
import { Control, LocalForm, Errors } from 'react-redux-form';
import { Link } from 'react-router-dom';
import { Loading } from '../common/LoadingComponent';
import SocialLogin from '../common/SocialLoginComponent';

const required   = (val) => val && val.length;
const maxLength  = (len) => (val) => !(val) || (val.length <= len);
const minLength  = (len) => (val) => val && (val.length >= len);
const validEmail = (val) => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(val);

class Login extends Component {
    constructor(props) {
        super(props);
        this.handleLogin = this.handleLogin.bind(this);
        this.props.resetLoginForm();
    }

    handleLogin(values) {
        this.props.authenticate(values.email, values.password, this.props.TokenDeviseRegister);
        this.props.resetLoginForm();
    }

    render() {
        if (this.props.isLogin) {
            return (
                <div className="auth-page">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 col-md-5">
                                <div className="auth-card text-center">
                                    <Loading />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="auth-page">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-5 col-lg-4">
                            <div className="auth-card">

                                <Link to="/home" className="auth-logo">eudeliv</Link>
                                <h1 className="auth-title">Bonjour, re-bonjour&nbsp;!</h1>
                                <p className="auth-subtitle">Connectez-vous pour envoyer ou transporter des colis.</p>

                                <LocalForm onSubmit={(values) => this.handleLogin(values)}>
                                    <div className="form-group mb-3">
                                        <Control.text
                                            model=".email"
                                            id="email"
                                            name="email"
                                            placeholder="Adresse e-mail"
                                            className="form-control auth-input"
                                            validators={{ required, validEmail }}
                                        />
                                        <Errors
                                            className="errors"
                                            model=".email"
                                            show="touched"
                                            messages={{
                                                required: 'Veuillez saisir votre e-mail.',
                                                validEmail: 'Format d\'e-mail invalide.'
                                            }}
                                        />
                                    </div>
                                    <div className="form-group mb-4">
                                        <Control.password
                                            model=".password"
                                            id="password"
                                            name="password"
                                            placeholder="Mot de passe"
                                            className="form-control auth-input"
                                            validators={{ required, maxLength: maxLength(30), minLength: minLength(8) }}
                                        />
                                        <Errors
                                            className="errors"
                                            model=".password"
                                            show="touched"
                                            messages={{
                                                required: 'Veuillez saisir votre mot de passe.',
                                                minLength: '8 caractères minimum.',
                                                maxLength: '30 caractères maximum.'
                                            }}
                                        />
                                    </div>
                                    <Button type="submit" color="primary" className="auth-submit mb-3">
                                        <strong>Se connecter</strong>
                                    </Button>
                                    <div className="text-center">
                                        <Link to="/demandresetpassword" className="auth-link">
                                            Mot de passe oublié ?
                                        </Link>
                                    </div>
                                </LocalForm>

                                <div className="auth-divider"><span>ou</span></div>

                                <SocialLogin
                                    isNotAndroidPlatform={this.props.isNotAndroidPlatform}
                                    TokenDeviseRegister={this.props.TokenDeviseRegister}
                                />

                                <div className="auth-footer mt-4">
                                    Pas encore de compte ?&nbsp;
                                    <Link to="/register" className="auth-link">Créer un compte</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Login;
